import { render, staticRenderFns } from "./TelegramList.vue?vue&type=template&id=3cb07424&"
import script from "./TelegramList.vue?vue&type=script&lang=js&"
export * from "./TelegramList.vue?vue&type=script&lang=js&"
import style0 from "./TelegramList.vue?vue&type=style&index=0&id=3cb07424&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports